import React from "react"
import Text from "./Text"
import { Spacing } from "../styles"

export default function Paragraph({ children, style }) {
  return <Text style={[{ marginBottom: Spacing.base }, style]}>{children}</Text>
}
